import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "react-emotion";

const themes = {
  success: "green",
  danger: "red",
  warning: "darkorange",
  info: "#007dbb"
};

const ThemedLabel = styled("label")`
  font-weight: bold;
  color: ${({ theme }) => themes[theme] || "black"};
`;

export default class Label extends Component {
  static propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    theme: PropTypes.oneOf(["default", "success", "danger", "warning", "info"]),
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
      PropTypes.string
    ])
  };

  static defaultProps = {
    theme: "default"
  };

  render = () => {
    let classNames = ["upn-component-label"];
    if (this.props.className) {
      classNames.push(this.props.className);
    }
    if (this.props.text) {
      console.error("The text prop is deprecated, use children instead.");
    }
    return (
      <ThemedLabel
        id={this.props.id}
        className={classNames.join(" ")}
        theme={this.props.theme}
      >
        {this.props.children}
      </ThemedLabel>
    );
  };
}
